import { inject, Injectable } from '@angular/core';
import { NavigationExtras, Router, UrlTree } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class BarRoutingService {
    readonly #router = inject(Router);

    /**
     * Will navigates to a given url and make sure the current component is not reused in case of a same route navigation (reload).
     * @param url
     */
    async navigateByUrlWithReload(url: string | UrlTree, extras?: NavigationExtras): Promise<boolean> {
        // navigate to the bar refresh route to then navigate to the same url (tricks of the trade)
        await this.#router.navigateByUrl('/bar-refresh', { skipLocationChange: true });
        // to then navigate back to the same page
        return await this.#router.navigateByUrl(url);
    }

    /**
     * Will navigates based on command array and make sure the current component is not reused in case of a same route navigation (reload).
     * @param url
     */
    async navigateWithReload(commands: any[], extras?: NavigationExtras): Promise<boolean> {
        // navigate to the bar refresh route to then navigate to the same url (tricks of the trade)
        await this.#router.navigateByUrl('/bar-refresh', { skipLocationChange: true });
        // to then navigate back to the same page
        return await this.#router.navigate(commands, extras);
    }
}
